import moment from 'moment-timezone';

import { ProcessAPI } from 'lecom-api';

export function getTimeZone() {
	return (ProcessAPI && ProcessAPI.currentProcess() && ProcessAPI.currentProcess().timeZone()) || 'America/Sao_Paulo';
}

export function getFormatDate(value) {
	if (typeof value === "number")
		return "";

	return ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY-MM-DD", "DD/MM/YYYY HH:mm", moment.ISO_8601];
}
